export var PhotoTagEntityType;
(function (PhotoTagEntityType) {
    PhotoTagEntityType["EVENT"] = "EVENT";
    PhotoTagEntityType["VENUE"] = "VENUE";
    PhotoTagEntityType["VENDOR"] = "VENDOR";
    PhotoTagEntityType["USER"] = "USER";
})(PhotoTagEntityType || (PhotoTagEntityType = {}));
//# sourceMappingURL=photo.js.map